var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 5,
    viewBox: "0 0 4 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.161004 1.82422L0.128636 1.49585C0.114931 1.35681 0.211961 1.21647 0.345038 1.18286L3.1096 0.468072C3.24332 0.433536 3.36251 0.518028 3.37543 0.656512L3.65886 3.53197C3.67257 3.67101 3.57554 3.81135 3.44246 3.84496L3.12667 3.92653C2.99153 3.96143 2.87126 3.87342 2.86026 3.73217L2.72926 1.98148L0.894637 4.63498C0.809736 4.75777 0.657528 4.79709 0.553236 4.72316L0.302308 4.54528C0.198015 4.47135 0.182415 4.31308 0.267316 4.19028L2.10194 1.53679L0.432521 2.01119C0.297036 2.04998 0.174216 1.96567 0.161004 1.82422Z",
    fill: "#F4F9FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.03f891db66d7af6af05e124d0b33448a.svg";
export { ForwardRef as ReactComponent };